require('./content')
require('./contact')
require('./login')
require('./account')
require('./homepage')
require('./sso')
require('./test')
